import { dateFormatPresets, formatDate } from '@thoughtspot/date-format-util';
export const dataColumnsEvents = [
    {
        id: '1',
        headerName: 'Time',
        minWidth: 100,
        valueGetter: (value) => {
            return formatDate(value * 1000, dateFormatPresets.DEFAULT_TIME_FORMAT);
        },
    },
    { id: '2', headerName: 'User', minWidth: 40 },
    { id: '3', headerName: 'Summary', minWidth: 400 },
];
export const prepareTableRowDataEvents = (data) => {
    if (!data)
        return [];
    return data.map((item) => {
        return {
            '1': item.system_info.at,
            '2': item.user,
            '3': item.summary,
        };
    });
};
export const dataColumnsAlerts = [
    {
        id: '1',
        headerName: 'Time',
        minWidth: 100,
        valueGetter: (value) => {
            return formatDate(value * 1000, dateFormatPresets.DEFAULT_TIME_FORMAT);
        },
    },
    { id: '2', headerName: 'Type', minWidth: 40 },
    { id: '3', headerName: 'Message', minWidth: 400 },
];
export const prepareTableRowDataAlerts = (data) => {
    if (data && !data.Admin_getAlerts.alert) {
        return [];
    }
    return data?.Admin_getAlerts.alert?.map((item) => {
        return {
            '1': item.at,
            '2': item.id,
            '3': item.system_info.msg,
        };
    });
};
//# sourceMappingURL=util.js.map